// extracted by mini-css-extract-plugin
module.exports = {"containerprin":"Servi_containerprin__3f_Es","containersecu":"Servi_containersecu__3fx_f","cajas":"Servi_cajas__t-f74"};